import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";


const ResultsTable = () => {
  const [marketData, setMarketData] = useState([]);
  console.warn(marketData)
  const navigate = useNavigate();

  useEffect(() => {
    fetchMarketData();
  }, []);

  const fetchMarketData = async () => {
    try {
      const response = await fetch("https://a-71ajsatta.com/Admin/public/api/getAllMarketData", {
        method: "POST",
      });
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      console.warn(data)
      console.log(data); // Log the response for debugging
      if (data.data && data.data.allMarketData) {
        setMarketData(data.data.allMarketData);
      }
    } catch (error) {
      console.error("Error fetching market data:", error);
    }
  };
  const convertTo24HourFormat = (time24Hour) => {
    const [hour, minute] = time24Hour.split(':');
    const hour12 = (hour % 12) || 12;
    const period = hour < 12 ? 'AM' : 'PM';
    return `${hour12}:${minute} ${period}`;
  };




  const handleClick2 = async (market_id) => {
    localStorage.removeItem("yearrr");
    navigate('/Markets');

    // alert(market_id)

    localStorage.setItem('marketchart_id', market_id,);

  };

  return (
    <section className="tablebox1">
      <div className="nopadding">
        <div className="table-responsive">
          <table className="table table-bordered table-striped table-hover">
            <thead className="forblack">
              <tr>
                <th className="col-md-4 text-center">सट्टा का नाम</th>
                <th className="col-md-4 text-center">कल आया था</th>
                <th className="col-md-4 text-center">आज का रिज़ल्ट</th>
              </tr>
            </thead>
            <tbody>
              {marketData.map((market, index) => (
                <tr key={index}>
                  <td className="foryellow">
                    <Link
                      to="/Markets"
                      className="gamenameeach"
                      onClick={() => {
                        handleClick2(market.market_id);
                      }}
                    >
                      {market.market_name}
                    </Link>

                    <br />
                    {convertTo24HourFormat(market.market_sunday_time_open)}
                    <br />
                    <button


                      to="/Markets"
                      className="btn"
                      onClick={() => {
                        handleClick2(market.market_id);
                      }}
                      style={{ fontSize: "12px", color: "#000", background: "#fff" }}
                    >
                      Record Chart
                    </button>
                  </td>
                  {/* <td>{market.yesterday_result}</td> */}
                  {/* <td>{market.today_result}</td> */}
                  <th>
                    {/* {market.yesterday_result <= 9 || market.yesterday_result === "" ? "Wait" : market.yesterday_result} */}
                    {/* {market.yesterday_result <= 9 || market.yesterday_result === "" ? (
                                  <div class="sattaresult"><font><span><strong><h1 class="text-red blink-soft">Wait</h1></strong></span></font></div>
                                ) : (
                                  market.yesterday_result                             )} */}

                    {(market.yesterday_result === "" || /^\d$/.test(market.yesterday_result)) ? (
                      <div className="sattaresult">
                        <font>
                          <span>
                            <strong>
                              <h1 className="text-red blink-soft">Wait</h1>
                            </strong>
                          </span>
                        </font>
                      </div>
                    ) : (
                      market.yesterday_result)}
                  </th>
                  <th>
                    {/* {market.today_result <= 9 || market.today_result === "" ? "Wait" : market.today_result} */}
                    {/* {market.today_result <= 9 || market.today_result === "" ? (
                                  <div class="sattaresult"><font><span><strong><h1 class="text-red blink-soft">Wait</h1></strong></span></font></div>
                                ) : (
                                  market.today_result                                )} */}

                    {(market.today_result === "" || /^\d$/.test(market.today_result)) ? (
                      <div className="sattaresult">
                        <font>
                          <span>
                            <strong>
                              <h1 className="text-red blink-soft">Wait</h1>
                            </strong>
                          </span>
                        </font>
                      </div>
                    ) : (
                      market.today_result)}
                  </th>



                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default ResultsTable;
